import { ObjectValues } from 'helpers/types';

export const FOR_INVESTORS_SECTIONS = {
  OVERVIEW: 'FOR_INVESTORS_OVERVIEW',
  EXECUTIVE_SUMMARY: 'FOR_INVESTORS_EXECUTIVE_SUMMARY',
  COMPANY_AND_PROJECT: 'FOR_INVESTORS_COMPANY_AND_PROJECT',
  MARKET_ANALYSIS: 'FOR_INVESTORS_MARKET_ANALYSIS',
  MARKETING_AND_SALES: 'FOR_INVESTORS_MARKETING_AND_SALES',
  BUSINESS_OPERATIONS: 'FOR_INVESTORS_BUSINESS_OPERATIONS',
  MANAGEMENT_AND_ORGANIZATION: 'FOR_INVESTORS_MANAGEMENT_AND_ORGANIZATION',
  RAISING_AND_ALLOCATING_FUNDS: 'FOR_INVESTORS_RAISING_AND_ALLOCATING_FUNDS',
  FINANCIAL_PLAN: 'FOR_INVESTORS_FINANCIAL_PLAN',
} as const;

export type IForInvestorsSections = ObjectValues<typeof FOR_INVESTORS_SECTIONS>;

export const FOR_INVESTORS_SUB_SECTIONS = {
  [FOR_INVESTORS_SECTIONS.OVERVIEW]: {
    COMPANY: 'company',
    PROJECT: 'project',
    MARKET_CUSTOMERS: 'marketAndCustomers',
    FINANCIAL_INFO: 'financialInfo',
    FUNDING_NEEDS: 'fundingNeeds',
  },
  [FOR_INVESTORS_SECTIONS.EXECUTIVE_SUMMARY]: {
    GOALS_AND_OBJECTIVES: 'goalsAndObjectives',
    COMPANY_DESCRIPTION: 'companyDescription',
    PRODUCTS_OR_SERVICES: 'productsOrServices',
    MARKET_AND_CUSTOMERS: 'marketAndCustomers',
    ORGANIZATION_AND_TEAM: 'organizationAndTeam',
    FINANCIAL_INFORMATION: 'financialInformation',
    FINANCING_NEEDS: 'financingNeeds',
  },
  [FOR_INVESTORS_SECTIONS.COMPANY_AND_PROJECT]: {
    GENERAL_INFO: 'generalInfo',
    COMPANY_HISTORY: 'companyHistory',
    ABOUT_THE_PROJECT: 'aboutTheProject',
    IMPLEMENTATION_PLAN: 'implementationPlan',
    SWOT: 'swotAnalysis',
  },
  [FOR_INVESTORS_SECTIONS.MARKET_ANALYSIS]: {
    MARKET_OVERVIEW: 'marketOverview',
    COMPETITIVE_ANALYSIS: 'competitiveAnalysis',
    CONSUMER_NEEDS: 'consumerNeeds',
  },
  [FOR_INVESTORS_SECTIONS.MARKETING_AND_SALES]: {
    SALES_PLAN: 'salesPlan',
    MARKETING_PLAN: 'marketingPlan',
  },
  [FOR_INVESTORS_SECTIONS.BUSINESS_OPERATIONS]: {
    LOCATION_AND_PREMISES: 'locationAndPremises',
    EQUIPMENT: 'equipment',
    ASSETS: 'otherAssets',
    TECHNOLOGICAL_PROCESS: 'technologicalProcess',
    PRODUCTION: 'production',
    PRODUCT_DESCRIPTION: 'description',
    UNIQUENESS: 'uniqueness',
  },
  [FOR_INVESTORS_SECTIONS.MANAGEMENT_AND_ORGANIZATION]: {
    MANAGEMENT_TEAM: 'managementTeam',
    STAFF_ORGANIZATION: 'staffOrganization',
  },
  [FOR_INVESTORS_SECTIONS.FINANCIAL_PLAN]: {
    KEY_ASSUMPTIONS: 'keyAssumptions',
    REVENUE_PLAN: 'revenuePlan',
    PLANNED_EXPENSES: 'plannedExpenses',
    PROFIT_AND_LOSS: 'profitAndLossProjection',
    CASH_FLOW_ELEMENTS: 'cashFlowElements',
    PROJECTED_CASH_FLOW: 'projectedCashFlow',
    FINANCIAL_PERFORMANCE: 'financialPerformance',
  },
} as const;

export type IForInvestorsSubSections = ObjectValues<typeof FOR_INVESTORS_SUB_SECTIONS>;

export type IForInvestorsOverviewSubSection = ObjectValues<typeof FOR_INVESTORS_SUB_SECTIONS.FOR_INVESTORS_OVERVIEW>;
export type IForInvestorsExecutiveSummarySubSection = ObjectValues<
  typeof FOR_INVESTORS_SUB_SECTIONS.FOR_INVESTORS_EXECUTIVE_SUMMARY
>;
export type IForInvestorsCompanyAndProjectSubSection = ObjectValues<
  typeof FOR_INVESTORS_SUB_SECTIONS.FOR_INVESTORS_COMPANY_AND_PROJECT
>;
export type IForInvestorsMarketAnalysisSubSection = ObjectValues<
  typeof FOR_INVESTORS_SUB_SECTIONS.FOR_INVESTORS_MARKET_ANALYSIS
>;
export type IForInvestorsMarketingAndSalesSubSection = ObjectValues<
  typeof FOR_INVESTORS_SUB_SECTIONS.FOR_INVESTORS_MARKETING_AND_SALES
>;
export type IForInvestorsBusinessOperationsSubSection = ObjectValues<
  typeof FOR_INVESTORS_SUB_SECTIONS.FOR_INVESTORS_BUSINESS_OPERATIONS
>;
export type IForInvestorsManagementAndOrganizationSubSection = ObjectValues<
  typeof FOR_INVESTORS_SUB_SECTIONS.FOR_INVESTORS_MANAGEMENT_AND_ORGANIZATION
>;

export type IForInvestorSubSection =
  | IForInvestorsOverviewSubSection
  | IForInvestorsExecutiveSummarySubSection
  | IForInvestorsCompanyAndProjectSubSection
  | IForInvestorsMarketAnalysisSubSection
  | IForInvestorsMarketingAndSalesSubSection
  | IForInvestorsBusinessOperationsSubSection
  | IForInvestorsManagementAndOrganizationSubSection;

export const FOR_INVESTORS_MAX_LENGTHS = {
  COMPANY_HISTORY: {
    EVENT: 500,
  },
  IMPLEMENTATION_PLAN: {
    STAGE: 150,
  },
};
